import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Axios from 'axios';
import NotFound from '../../images/not-found.png';
import { BASE_URL } from 'utils/constants';
import parse from 'html-react-parser';

const SingleCompanyPage = () => {
  const [company, setCompany] = useState(null);
  const params = useParams();

  useEffect(() => {
    window.scrollTo(0, 0);

    Axios.get(`${BASE_URL}/api/company/` + params.id).then(({ data }) => {
      setCompany(data);
    });
  }, [params.id]);

  return (
    <div className="single-company-container">
      {company && (
        <div className=" single-company justify-content-evenly">
          <div className=" child-35 basic-info">
            <h2 className="basic-info-name">{company.name}</h2>
            {company.images ? (
              <img alt="company" src={`${BASE_URL}/${company.images.url}`} />
            ) : (
              <img alt="not-found" src={NotFound}></img>
            )}

            <div className="d-flex basic-info-box">
              <p className="basic-info-box-name">Adresa: </p>
              <p className=" ml-3">{company.address}</p>
            </div>
            <div className="d-flex basic-info-box">
              <p className="basic-info-box-name">Grad: </p>
              <p className="ml-3">{company.town}</p>
            </div>
            <div className="d-flex basic-info-box">
              <p className="basic-info-box-name">Drzava: </p>
              <p className="ml-3">{company.state ? company.state : 'Srbija'}</p>
            </div>
            {company.phone && (
              <div className="d-flex basic-info-box">
                <p className="basic-info-box-name">Telefon: </p>
                <p className="ml-3">{company.phone}</p>
              </div>
            )}
            {company.mobile && (
              <div className="d-flex basic-info-box">
                <p className="basic-info-box-name">Mobilni: </p>
                <p className="ml-3">{company.mobile}</p>
              </div>
            )}
            {company.fax && (
              <div className="d-flex basic-info-box">
                <p className="basic-info-box-name">Fax: </p>
                <p className="ml-3">{company.fax}</p>
              </div>
            )}
            {company.email && (
              <div className="d-flex basic-info-box">
                <p className="basic-info-box-name">Email: </p>
                <p className="ml-3">{company.email}</p>
              </div>
            )}
            {company.web && (
              <div className="d-flex basic-info-box">
                <p className="basic-info-box-name">Web: </p>
                <p className="ml-3">
                  <a
                    href={`http://${company.web.trim()}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {' '}
                    {company.web}
                  </a>
                </p>
              </div>
            )}
          </div>
          {company.description && (
            <p className="child-48 info-text">
              {company.description && parse(company.description)}
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default SingleCompanyPage;
